import React, { Component } from "react";
import { connectCurrentRefinements } from "react-instantsearch-dom";

const filterList = ["is_award_winner", "is_unclaimed", "story_count"];

const CurrentRefinements = ({ items, refine, createURL }) => {
  console.log("CurrentRefinements", items);
  const SHOW = items.length > 1;
  const list = items.map((item) => {
    if (filterList.includes(item.id)) {
      let label = item.label;
      if (item.id === "story_count") {
        label = item.label.replace("story_count", "Stories");
      }
      return (
        <React.Fragment>
          <div
            key={item.label}
            className="tag form__tag"
            onClick={(event) => {
              event.preventDefault();
              refine(item.value);
            }}
          >
            <span>{label}</span>
            <a href="#" className="remove" tabIndex="-1" title="Remove">
              x
            </a>
          </div>
        </React.Fragment>
      );
    }

    if (item.items)
      return (
        <React.Fragment>
          {item.items.map((nested) => (
            <div
              key={nested.label}
              className="tag form__tag"
              onClick={(event) => {
                event.preventDefault();
                refine(nested.value);
              }}
            >
              <span>{nested.label}</span>
                <a href="#">
                  <svg
                    version="1.1"
                    id="Layer_1"
                    x="0px"
                    y="0px"
                    viewBox="0 0 12.8 12.8"
                  >
                    <polygon
                      fill="currentColor"
                      points="12.8,1 11.8,0 6.4,5.4 1,0 0,1 5.4,6.4 0,11.8 1,12.8 6.4,7.4 11.8,12.8 12.8,11.8 7.4,6.4 "
                    ></polygon>
                  </svg>
                </a>

            </div>
          ))}
        </React.Fragment>
      );
  });
  return <div className="form__tags">{list}</div>
};

const CurrentRefinementList = connectCurrentRefinements(CurrentRefinements);
export default CurrentRefinementList;
